<script lang="ts">
  import StatusTag from "@kontextwerk/web-sdk/ui/display/StatusTag.svelte"
  import { RICH_TOOLTIP_CLASS } from "../../../../../../../../../../_shared/_logic/rich-tooltips"
  import type { AddressUnitBadge } from "../../_shared/_logic/address-table-contract"

  let { rowId, badges = [] }: { rowId: string | number | undefined; badges?: AddressUnitBadge[] } =
    $props()
</script>

{#if badges.length}
  <div class="unit-tags">
    {#each badges as badge (`${rowId}-${badge.id}`)}
      <StatusTag
        variant="neutral"
        size="sm"
        label={badge.label}
        color={badge.color}
        tooltipContent={badge.tooltip}
        tooltipHtml={true}
        tooltipClassName={RICH_TOOLTIP_CLASS}
      />
    {/each}
  </div>
{:else}
  <span>–</span>
{/if}

<style lang="less">
  .unit-tags {
    display: inline-flex;
    min-width: 0;
    max-width: 100%;
    flex-direction: column;
    gap: 0.35rem;
    align-items: flex-start;
  }
</style>
